/**
 * EYEMODE - Color Swatch Image Swap
 * Click swatch = change first image to that color's image
 * Hover = show second image of that color
 */
document.addEventListener('DOMContentLoaded', function() {
  
  document.body.addEventListener('click', function(e) {
    var swatch = e.target.closest('.card-color-swatch');
    if (!swatch) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    // Get the card wrapper
    var card = swatch.closest('.product-card-wrapper') || swatch.closest('.card-wrapper') || swatch.closest('li');
    if (!card) return;
    
    // Get ALL images in the card media area
    var images = card.querySelectorAll('.card__media img, .media--hover-effect img');
    if (images.length === 0) return;
    
    var primaryImg = images[0];
    var secondaryImg = images.length > 1 ? images[1] : null;
    
    // Update active state on swatches
    var allSwatches = swatch.parentElement.querySelectorAll('.card-color-swatch');
    allSwatches.forEach(function(s) { s.classList.remove('card-color-swatch--active'); });
    swatch.classList.add('card-color-swatch--active');
    
    // Get image URLs from data attributes
    var newPrimarySrc = swatch.dataset.imageSrc;
    var newPrimarySrcset = swatch.dataset.imageSrcset;
    var newSecondarySrc = swatch.dataset.imageSecondarySrc;
    var newSecondarySrcset = swatch.dataset.imageSecondarySrcset;
    
    // UPDATE PRIMARY IMAGE (the main visible image)
    if (newPrimarySrc && primaryImg) {
      primaryImg.src = newPrimarySrc;
      if (newPrimarySrcset) primaryImg.srcset = newPrimarySrcset;
    }
    
    // UPDATE SECONDARY IMAGE (the hover image)
    if (secondaryImg) {
      if (newSecondarySrc) {
        secondaryImg.src = newSecondarySrc;
        if (newSecondarySrcset) secondaryImg.srcset = newSecondarySrcset;
      } else if (newPrimarySrc) {
        secondaryImg.src = newPrimarySrc;
        if (newPrimarySrcset) secondaryImg.srcset = newPrimarySrcset;
      }
    }
    
    return false;
  });
  
  // Mobile touch support
  document.body.addEventListener('touchend', function(e) {
    var swatch = e.target.closest('.card-color-swatch');
    if (swatch) {
      e.preventDefault();
      swatch.click();
    }
  }, {passive: false});
  
});
